'use client';
import { createParser } from 'nuqs';

import { parseFiltersQuery, serializeFiltersQuery } from './filtersQuery';

export const parseAsObject = createParser({
  parse: parseFiltersQuery,
  serialize: serializeFiltersQuery
});
